/**
* this is the account pages which show the member profile
*
* Created by Min on 10/08/18
*/

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import cx from 'classnames'
import { connect } from 'react-redux'

// action import
import { ActionCreator } from '../../actions/'

// component import
import ProfileLanding from '../../components/ProfileLanding'
import ProfileForm from '../../components/ProfileForm'

// style import
import './style.scss'


class Account extends Component {
    componentDidMount() {
        const { editProfile } = this.props
        editProfile(false)
    }

    render() {

        let content

        if(this.props.isEditing) {
            content = <ProfileForm initialValues ={this.props.data} />
        }
        else {
            content = <ProfileLanding data={this.props.data} />
        }

        // show/hide loader based on the truthy value 'isLoading'
        const dynClassLoader = cx('profile__loader', {
            'profile__loader--show': this.props.isLoading
        })

        // show/hide the profile based on whether there is 'data' to be displayed
        const dynClassContent = cx('profile__content', {
            'profile__content--show':!this.props.isLoading
        })

        return (
            <div className="account main-wrapper">
                <div className="main-container">
                    <div className="content-container">
                        <div className="page-title">UPDATE MY PROFILE</div>
                        <div className="account-introtext">
                            <p>Here you can update your Selfmade account information. Changing these details will not change the information in your fund. </p>
                            <p>To update your fund information, please contact an administrator.</p>
                        </div>

                        {/* loader */}
                        <div className={dynClassLoader}>
                            <div className="animated-bg animated-bg--long"></div>
                            <div className="animated-bg animated-bg--short"></div>
                            <div className="animated-bg animated-bg--long"></div>
                            <div className="animated-bg animated-bg--short"></div>
                            <div className="animated-bg animated-bg--long"></div>
                        </div>

                        {/* profile content */}
                        <div className={dynClassContent}>
                            {content}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

// define the prop types
Account.propTypes = {
    data: PropTypes.object,
    isEditing: PropTypes.bool,
    isLoading: PropTypes.bool,
}

// pull props to this container
const mapStateToProps = (state) => {
    return {
        data: state.profileState.data,
        isEditing: state.profileState.isEditing,
        isLoading: state.profileState.isLoading,
    }
}

const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        editProfile: action.editProfile
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(Account)



// WEBPACK FOOTER //
// ./src/pages/Account/index.js